import type { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HELP_SECTIONS } from '@shared/help';
import { TopBar } from '@shared/ui/v2';

/**
 * Временная обёртка прежних страниц (Баланс, Настройки, Обучение) в каркас v2:
 * верхняя строка и отступы как у новых экранов. Убирается, когда страница
 * переписана по утверждённому экрану.
 */
export function LegacyPage({ title, hint, children }: { title: string; hint?: string; children: ReactNode }) {
  return (
    <>
      <TopBar title={title} hint={hint} />
      <div className="v2-content">{children}</div>
    </>
  );
}

/** «Помощь и обучение»: разделы статей — вкладками под верхней строкой. */
export function HelpPage({ children }: { children: ReactNode }) {
  const pathname = useLocation().pathname.replace(/\/+$/, '') || '/';
  const tabs = [{ to: '/getting-started', label: 'С чего начать' }].concat(
    HELP_SECTIONS.map((s) => ({ to: `/getting-started/${s.slug}`, label: s.name })),
  );
  return (
    <>
      <TopBar title="Помощь и обучение" />
      <div className="v2-content">
        <div role="tablist" style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {tabs.map((t) => {
            const active = pathname === t.to;
            return (
              <Link
                key={t.to}
                to={t.to}
                role="tab"
                aria-selected={active}
                className="v2-btn"
                style={active ? { background: '#1F2937', color: '#fff', borderColor: '#1F2937' } : undefined}
              >
                {t.label}
              </Link>
            );
          })}
        </div>
        {children}
      </div>
    </>
  );
}
